<template>
  <footer class="home-footer">
    <div class="row logos">
      <div class="logos">
        <div class="title">Nossas Marcas</div>
        <br />
        <img src="@/assets/w-b-c-logo.jpg" />
      </div>
    </div>
    <div class="row copyright">
      <p class="is-light">
        Copyright WHIRLPOOL S.A. ® 2017 – Todos os Direitos Reservados.CNPJ
        59.105.999/0001-86. <br />Avenida das Nações Unidas, 12995 - Vila
        Almeida, São Paulo - SP, CEP: 04795-100 |
        gcg-devolucao_comercial@whirlpool.com
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "HomeFooter"
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_colors.scss";

.home-footer {
  background-color: $grey4;
  color: $grey2;
  font-size: 14px;
  height: 218px;
  padding-top: 44px;
  margin-top: 30px;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;

  .copyright {
    justify-content: flex-start;
  }

  .logos {
    justify-content: flex-end;
  }

  .row {
    display: flex;
    width: 1022px;
    margin-left: auto;
    padding-left: 10px;
    margin-right: auto;
    padding-right: 10px;

    .links {
      padding: 35px 10px 0 10px;
    }

    .logos {
      padding: 0 10px 0 10px;
      margin-right: 30px;

      .title {
        font-size: 16px;
        margin-bottom: 5px;
      }

      img {
        width: 300px;
        height: 65px;
      }
    }

    .is-light {
      opacity: 0.5;
    }
  }
}
</style>
